<app-kontable
  #storesTable
  title="Negozi"
  [columns]="[
    'code',
    'host_code',
    'name',
    'description',
    'city',
    'countryName',
    'salesNetworkName'
  ]"
  [titles]="[
    'Codice',
    'Codice Host',
    'Nome',
    'Descrizione',
    'Città',
    'Paese',
    'Rete Vendita'
  ]"
  [service]="storeCommonSvc"
  [showDetailsButton]="false"
  [showInfoButton]="false"
  [showEditButton]="false"
  [showGlobalFilter]="false"
  [showRecoverButton]="false"
  [showDeleteButton]="false"
  [showReport]="false"
  [paginationType]="paginationType"
  [additionalRowCommands]="customActions"
>
  <ng-template #customActions data-testid="customActions" let-row>
    <p-button pTooltip="{{ 'common.select' | translate }}" icon="fa fas fa-arrow-circle-right"  styleClass="ui-button-info" (onClick)="selectStore(row)"></p-button>
  </ng-template>
</app-kontable>



// WEBPACK FOOTER //
// ./src/app/views/administration/store/store-group/store-selection-table/store-selection-table.component.html